module.exports = __webpack_public_path__ + "img/智驹首页轮播图Z86---2.2a5a511f.jpg";